import {Context} from "react";
import {useContext} from 'react';

// type NonNullable<S, C> = Exclude<<S, C, null>;

export function useRequiredLayers<S, C>(storeContext: Context<S>, controllerContext: Context<C>): { store: S; controller: C; } {
    return {store: useContext<S>(storeContext), controller: useContext<C>(controllerContext)};
}
